<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input placeholder="请输入员工ID" v-model="params.value" size="small"></el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.opType" placeholder="请选择" size="small">
                        <el-option label="不限行为类型" :value="0"></el-option>
                        <el-option label="仅看新增的" :value="1"></el-option>
                        <el-option label="仅看管理的" :value="2"></el-option>
                        <el-option label="仅看页面访问的" :value="3"></el-option>
                        <el-option label="仅看导出的" :value="4"></el-option>
                        <el-option label="仅看导入的" :value="5"></el-option>
                        <el-option label="仅看登录的" :value="6"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="10" :lg="10" :xl="6">
                    <el-date-picker v-model="daterange" type="daterange" range-separator="至" start-placeholder="操作时间"
                        end-placeholder="操作时间" value-format="yyyy-MM-dd HH:mm:ss" unlink-panels size="small">
                    </el-date-picker>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-list-box">
            <el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe>
                <el-table-column prop="createTime" label="操作时间"></el-table-column>
                <el-table-column prop="accId" label="ID"></el-table-column>
                <el-table-column prop="accAccount" label="姓名"></el-table-column>
                <el-table-column prop="page" label="页面"></el-table-column>
                <el-table-column prop="behaviorType" label="行为类型">
                    <template slot-scope="scope">{{ behaviorType.get(scope.row.behaviorType) }}</template>
                </el-table-column>
                <el-table-column prop="behaviorDec" label="行为描述"></el-table-column>
                <el-table-column prop="ipAddress" label="访问IP"></el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
                :current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next" :total="data.totalCount || 0">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import template from '../../operation/chatGroup/template.vue';
const defaultParams = {
    pageNo: 1,
    type: 1,
    value: '',
    rangeStart: '',
    rangeEnd: '',
    opType: 0,
}
export default {
    components: { template },
    data() {
        return {
            data: null,
            dataList: null,
            daterange: [],
            params: {
                ...defaultParams,
                pageSize: this.$pageSizes[0],
                value: this.$route.query.id || '',
            },
            listLoading: true,
        }
    },
    computed: {
        behaviorType() {
            return new Map([
                [1, '新增'], [2, '管理'], [3, '页面访问'], [4, '导出'], [5, '导入'], [6, '登录']
            ])
        }
    },
    created() {
        let startTime = ''
        let endTime = ''
        let yy = new Date().getFullYear();
        let mm = new Date().getMonth() + 1;
        let dd = new Date().getDate();
        let hh = new Date().getHours();
        let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes();
        let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds();
        startTime = yy - 1 + '-' + mm + '-' + dd + ' ' + hh + ':' + mf + ':' + ss;
        endTime = yy + '-' + mm + '-' + dd + ' ' + hh + ':' + mf + ':' + ss;
        this.daterange = [startTime, endTime]
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表

        getDataList() {
            this.listLoading = true;
            this.params = {
                ...this.params,
                rangeStart: this.daterange ? this.daterange[0] : '',
                rangeEnd: this.daterange ? this.daterange[1] : '',
            }
            this.$request({
                url: '/access/log/list',
                method: 'POST',
                data: this.params
            }).then(res => {
                const { state, msg, result } = res.data;
                if (state && result) {
                    this.data = result;
                    this.dataList = result.result || [];
                    console.log(this.daterange)
                } else {
                    this.$message.error(msg || '请求失败');
                }
            }).catch(() => {
                this.$message.error('请求错误');
            }).finally(() => {
                this.listLoading = false;
            });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1
            this.params.pageSize = e
            this.getDataList()
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.daterange = [];
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        }
    }
}
</script>